import { HttpClient } from '@angular/common/http';
import { Injectable , inject} from '@angular/core';
import { Observable } from 'rxjs';
import { AddressBook } from './address-book';
import { AddressBookEntry } from './address-book-entry/address-book-entry';
import { ExtendedContact } from '@app/shared/extended-contact/extended-contact';
import { toIsoStringWithOffset } from '@app/shared/utilities/toolbox';

@Injectable({
	providedIn: 'root'
})
export class AddressBookService {
	private _http = inject(HttpClient);

	private readonly ADDRESS_BOOK_URL: string = 'api/addressbooks';



	getAddressBook(customerCode: string): Observable<AddressBook> {
		return this._http.get<AddressBook>(`${this.ADDRESS_BOOK_URL}/${customerCode}?api-version=1.0`);
	}

	saveEntry(customerCode: string, newEntry: AddressBookEntry): Observable<AddressBookEntry> {
		return this._http.post<AddressBookEntry>(`${this.ADDRESS_BOOK_URL}/${customerCode}/entries?api-version=1.0`, newEntry);
	}

	saveContact(customerCode: string, newContact: ExtendedContact): Observable<any> {
		return this._http.post(`${this.ADDRESS_BOOK_URL}/${customerCode}/entries/${newContact.entryIdentifier}/contacts?api-version=1.0`, newContact);
	}

	patchEntry(customerCode: string, entryIdentifier: string, patch: AddressBookEntry): Observable<any> {
		return this._http.patch(`${this.ADDRESS_BOOK_URL}/${customerCode}/entries/${entryIdentifier}?api-version=1.0`, patch);
	}

	updateContact(customerCode: string, entryIdentifier: string, contact: ExtendedContact): Observable<any> {
		return this._http.patch(`${this.ADDRESS_BOOK_URL}/${customerCode}/entries/${entryIdentifier}/contacts/${contact.identifier}?api-version=1.0`, contact);
	}

	recordEntryUsage(customerCode: string, entryIdentifier: string, usageDateTime: Date) {
		return this._http.post(`${this.ADDRESS_BOOK_URL}/${customerCode}/entries/${entryIdentifier}/usages?api-version=1.0`, {
			usageDateTime: toIsoStringWithOffset(usageDateTime)
		});
	}

	import(customerCode: string, file: File) {
		const formData = new FormData();
		formData.append('formFile', file, file.name);
		return this._http.post(`${this.ADDRESS_BOOK_URL}/${customerCode}/import?api-version=1.0`, formData);
	}

	deleteEntry(customerCode: string, entryIdentifier: string): Observable<{}> {
		return this._http.delete(`${this.ADDRESS_BOOK_URL}/${customerCode}/entries/${entryIdentifier}?api-version=1.0`);
	}
}
